// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"d05a6795","264":"5ddea355","290":"5c1e10c3","358":"12c3f793","420":"6ecde927","571":"82c7d47f","672":"50d1e0d0"}[chunkId] + ".chunk.js";
};